import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons';

// components
import { YesNo, TextInput, TextBlock } from '../components/inputs';
import { FormRow } from '../components/layout';

// utils + actions
import { evaluateConditions } from '../../../common/utils/enrollment';

function ExternalProviderLink({ link, carrier }) {
  return (
    <a
      className="d-flex btn btn-link justify-content-start align-items-center"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      View {carrier}&apos;s provider directory
      <FontAwesomeIcon icon={faExternalLink} className="ms-2" />
    </a>
  );
}

function WrappedTextInput({ label, name, cols }) {
  return (
    <TextInput
      label={label}
      name={name}
      cols={cols}
      className="mb-3"
    />
  );
}

function PCP() {
  const dispatch = useDispatch();
  const {
    form: {
      providerLookupLink,
      providerLookupLinkOverrides = [],
      carrierName,
    },
    theme: {
      carrierProviderLinks,
      providerSearch,
    },
    values,
  } = useSelector(store => store);

  let lookupOverride = {};
  let useOverride = false;
  providerLookupLinkOverrides.forEach(override => {
    useOverride = evaluateConditions({ currentValues: values, conditions: (override.conditions || []) });
    if (useOverride) lookupOverride = override;
  });

  return (
    <div>
      {carrierProviderLinks && providerLookupLink && !useOverride && (
        <FormRow>
          <ExternalProviderLink link={providerLookupLink} carrier={carrierName} />
        </FormRow>
      )}

      {useOverride && (
        <FormRow>
          <TextBlock
            name="additional_provider_instrucitons"
            textOverride={lookupOverride.additionalInstructions}
          />
          <ExternalProviderLink link={lookupOverride.link} carrier={carrierName} />
        </FormRow>
      )}

      {providerSearch && (
        <FormRow>
          <div className="col">
            <button
              type="button"
              tabIndex={0}
              className="btn btn-primary btn-p"
              onClick={() => dispatch({ type: 'OPEN_MODAL', modal: 'doctorsModal' })}
            >
              Find Provider
            </button>
          </div>
        </FormRow>
      )}

      <FormRow>
        <YesNo
          label="Are you an established patient?"
          name="pcp_established"
        />
      </FormRow>

      <FormRow>
        <WrappedTextInput
          label="Physician first name"
          name="pcp_first_name"
          cols="6"
        />
        <WrappedTextInput
          label="Physician middle name"
          name="pcp_middle_name"
          cols="6"
        />
        <WrappedTextInput
          label="Physician last name"
          name="pcp_last_name"
          cols="6"
        />
        <WrappedTextInput
          label="Physician name"
          name="pcp_name"
          cols="6"
        />
        <WrappedTextInput
          label="Provider number"
          name="pcp_num"
          cols="6"
        />
        <WrappedTextInput
          label="Primary Medical Group"
          name="pcp_pmg"
          cols="6"
        />
        <WrappedTextInput
          label="Primary care ID"
          name="primarycare_id"
          cols="6"
        />
        <WrappedTextInput
          label="WellCare IPA"
          name="pcp_ipa"
          cols="6"
        />
        <WrappedTextInput
          label="Physician address"
          name="pcp_street1"
          cols="6"
        />
        <WrappedTextInput
          label="Physician city"
          name="pcp_city"
          cols="6"
        />
        <WrappedTextInput
          label="Physician state"
          name="pcp_state"
          cols="6"
        />
        <WrappedTextInput
          label="Physician zipcode"
          name="pcp_zip"
          cols="6"
        />
      </FormRow>
    </div>
  );
}

export default PCP;
